export default class Constants {
  public static readonly baseUrl = 'http://childdonor.uz/api/v1.0';
 // public static readonly baseUrl = 'https://v2.bmdd.info/api/v1.0';
 // public static readonly statisticsUrl = 'https://v2.bmdd.info:5007/api/v1.0';
  public static readonly statisticsUrl = 'http://childdonor.uz/api/v1.0';
  public static readonly maxPageSize = 2147483647;
  public static readonly RelativePatient = 2;

  public static RevertStatusMessageTemplate = '<span style="color:black; font-size: 18px">Это действие отменит текущий статус. <br/>Будет выставлен предыдущий статус <b>"#status#"</b>. <br/>Выполнить операцию?</span>';
}
